import { NonEmptyArray } from '../../../../../../JsonQuery';
import { ESaleType } from 'shared/repositories/common/json_query';

interface IPrepareValueProps {
  value: NonEmptyArray<ESaleType> | null;
  allowedValues: NonEmptyArray<ESaleType>;
}

export const prepareValue = ({ value, allowedValues }: IPrepareValueProps): NonEmptyArray<ESaleType> | null => {
  if (!value) {
    return null;
  }

  const filtered = value.filter(item => allowedValues.includes(item));

  return filtered.length ? (filtered as NonEmptyArray<ESaleType>) : null;
};
